/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './ActiveLoansTile.css';
import { Grid } from '@mui/material';
import { fonts, themes } from '../../themes/themes';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { DateField } from '../../../components';
import { baseDateFormatting } from '../../helper';

interface contentTileType {
  loanName: string;
  amount: string;
  duration: number;
  submitted: string;
  status?: any;
  isFinished?: boolean;
  onClickView?: any;
  completedPaidAmount?: any;
  pendingAmount?: any;
}
const ActiveLoansTile: React.FC<contentTileType> = ({
  submitted,
  loanName,
  duration,
  amount,
  status,
  isFinished,
  onClickView,
  completedPaidAmount,
  pendingAmount
}) => {
  const { t } = useTranslation();
  const trans = t;

  return (
    <Grid container className="leaveApplied-container">
      <Grid item xs={11}>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.title,
              fontFamily: fonts.fontFamily,
              color: themes.blackDefault,
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {loanName}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '5px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Duration')} :{' '}
            <span
              style={{
                color: themes.blackDefault,
                fontWeight: 'bold',
                fontFamily: fonts.fontFamily,
              }}
              className="mx-1"
            >
              {duration} {trans('Months')}
            </span>{' '}
            |
            {isFinished ? (
              <>
                <span
                  style={{
                    color: themes.defaultError,
                    fontFamily: fonts.fontFamily,
                  }}
                  className="mx-1"
                >
                  {' '}
                  {trans('Submission Date')} :{' '}
                </span>
                <span
                  style={{
                    color: themes.defaultError,
                    fontFamily: fonts.fontFamily,
                  }}
                >
                  <DateField value={submitted} format={baseDateFormatting} />
                </span>
              </>
            ) : (
              <>
                <span style={{ fontFamily: fonts.fontFamily }} className="mx-1">
                  {' '}
                  {trans('Submitted')}:{' '}
                </span>
                <span
                  style={{
                    color: themes.blackDefault,
                    fontFamily: fonts.fontFamily,
                    fontWeight: 'bold',
                  }}
                >
                  <DateField value={submitted} format={baseDateFormatting} />
                </span>
              </>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              color: themes.defaultIcon,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              textTransform: 'capitalize',
              letterSpacing: '0.01px',
              marginTop: '2px',
            }}
          >
            {trans('Amount')} :
            <span
              style={{
                color: themes.blackDefault,
                fontWeight: 'bold',
                fontFamily: fonts.fontFamily,
              }}
              className="mx-1"
            >
              {' '}
              {amount}
            </span>{' '}
            |
            {trans('Paid Amount')} :
            <span
              style={{
                color: themes.blackDefault,
                fontWeight: 'bold',
                fontFamily: fonts.fontFamily,
              }}
              className="mx-1"
            >
              {' '}
              {completedPaidAmount}
            </span>{' '}
            |
            {trans('Pending Amount')} :
            <span
              style={{
                color: themes.blackDefault,
                fontWeight: 'bold',
                fontFamily: fonts.fontFamily,
              }}
              className="mx-1"
            >
              {' '}
              {pendingAmount}
            </span>{' '}
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              fontSize: fonts.subtitle,
              fontFamily: fonts.fontFamily,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              letterSpacing: '0.01px',
              marginTop: '2px',
              textTransform: 'capitalize',
            }}
          >
            {trans('Status')}:{' '}
            {status == 0 ? (
              <span style={{ color: themes.defaultError }} className="mx-1">
                {trans('Pending')}
              </span>
            ) : status == 2 ? (
              <span style={{ color: themes.defaultError }} className="mx-1">
                {trans('Rejected')}
              </span>
            ) : status == 1 ? (
              <span style={{ color: themes.defaultSuccess }} className="mx-1">
                {trans('Approved')}
              </span>
            ) : status == 4 ? (
              <span style={{ color: themes.defaultError }} className="mx-1">
                {trans('On-Going')}
              </span>
            ) : (
              <span style={{ color: themes.defaultMisc }} className="mx-1">
                {trans('Closed')}
              </span>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Box className="icon-box_active_loans" onClick={onClickView}>
              {' '}
              <i className="las la-eye" />{' '}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ActiveLoansTile;
